import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/truckin/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/truckin',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/truckin/detail/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/truckin/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/truckin/' + id,
method: 'put',
data: obj
})
}
